import { getAnonymousFeedbackId } from "./feedbackIdentity";

const FEEDBACK_SUCCESS_PREFIX = "venaqqi_feedback_success_v1";
const recognitionAudience = userId => userId ? `user:${userId}` : `anonymous:${getAnonymousFeedbackId()}`;
const recognitionKey = userId => `${FEEDBACK_SUCCESS_PREFIX}:${encodeURIComponent(recognitionAudience(userId))}`;

export const hasSuccessfulFeedback = userId => {
  try { return localStorage.getItem(recognitionKey(userId)) === "1"; }
  catch { return false; }
};

export const markSuccessfulFeedback = userId => {
  try { localStorage.setItem(recognitionKey(userId), "1"); }
  catch { /* El envío remoto sigue siendo válido si localStorage no está disponible. */ }
};
